import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import classNames from 'classnames';

import type { SystemFleetFormFieldProps } from './types';

import './_styles.scss';

const InputText = ({
    label,
    required,
    error,
    errorMessage,
    register,
    defaultValue,
    value,
    name,
    onChange,
}: SystemFleetFormFieldProps) => {
    const setLabel = required ? (
        <div className='InputText__madatoryLabel'>
            <OverlayTrigger
                placement='top-start'
                overlay={
                    <Tooltip>
                        <p>Mandatory field</p>
                    </Tooltip>
                }
            >
                <label className='InputText__label' htmlFor={name}>
                    {label}
                </label>
            </OverlayTrigger>
            <span className='InputText__mandatoryIcon'>*</span>
        </div>
    ) : (
        <label className='InputText__label' htmlFor={name}>
            {label}
        </label>
    );

    return (
        <div className='InputText'>
            {setLabel}
            <input
                className={classNames('InputText__field form-control', {
                    'InputText__field--error': error,
                })}
                required={required}
                type='text'
                value={value}
                defaultValue={defaultValue}
                {...(register(name),
                {
                    onChange,
                })}
            />
            {!!error && !!errorMessage && <span className='InputText__errorMessage'>{errorMessage}</span>}
            {!!error && (
                <div className='InputText__errorIcon'>
                    <span className='rioglyph rioglyph-error-sign' />
                </div>
            )}
        </div>
    );
};

export default InputText;
